import React, {
  useState,
  useEffect,
}                      from 'react';
import ReCAPTCHA       from "react-google-recaptcha";
import { useLocation } from "react-router-dom";
import {
  FormattedMessage,
  useIntl,
}                      from 'react-intl';

const MAPPEX_URL = process.env.MAPP_EXTERNALS_BASE_URL;

const ResetPasswordRequest = () => {

  const { formatMessage } = useIntl();

  const [captcha_key, setCaptchaKey] = useState(null);
  const recaptchaRef = React.createRef();
  const [captcha_token, setCaptchaToken] = useState(null);
  const [email_address, setEmailAddress] = useState('');
  const { search } = useLocation();
  const displayUnblockCaptcha = async () => {
    await fetch(`${MAPPEX_URL}services/google/captcha/sitekey/reset_password`)
      .then(res => res.ok && res.text() || Promise.reject(`Unexpected status ${res.status} at ${res.url}`))
      .then(setCaptchaKey);
  };

  useEffect(() => {
    displayUnblockCaptcha();
  }, []);

  useEffect(() => {
    setEmailAddress(new URLSearchParams(search).get('email'));
  }, [search]);

  const sendPasswordResetRequest = (email_address, captcha_token) => (
    fetch('/request_password_reset', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accepts': 'application/json',
      },
      body: JSON.stringify({
        email: email_address,
        captcha_response: captcha_token,
      }),
    }).then(() => {
      alert(formatMessage({ defaultMessage: 'Se ha enviado un email con instrucciones para la recuperación a {email_address}' }, { email_address }));
    }).catch(() => {
      alert(formatMessage({ defaultMessage: 'Ha ocurrido un error inesperado. Contacte con support@walcu.com' }));
    })
  );


  return (
    <>
      <h1 style={{ flex: 0.25 }}>
        <FormattedMessage defaultMessage='Petición de cambio de contraseña' />
      </h1>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
          alignItems: 'center',
          justifyContent: 'flex-start',
          flex: 1,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <label>
            <FormattedMessage defaultMessage='Email' />
          </label>
          <input
            type='email'
            placeholder='Email'
            onChange={e => setEmailAddress(e.target.value)}
            value={email_address}
            className='input'
            style={{ padding: '1.5em' }}
          />
        </div>
        {captcha_key && (
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={captcha_key}
            onChange={setCaptchaToken}
          />
        )}
        <button
          onClick={() => sendPasswordResetRequest(email_address, captcha_token)}
          className='button-primary button-medium'
          disabled={!captcha_token}
        >
          <FormattedMessage defaultMessage='Solicitar cambio de contraseña' />
        </button>
      </div>
    </>
  );
};
export default ResetPasswordRequest;
